<template>
  <div>
    <div class="container-block" style="margin:15px 0;">
      <a-form-model layout="inline">
        <a-form-model-item label="名称">
          <a-input style="width:200px" placeholder="任务名称"
            @pressEnter="getList({current:1,pageSize:pagination.pageSize})" v-model="search.taskName" />
        </a-form-model-item>
        <a-form-model-item label="创建日期">
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="search.taskDate" />
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click="getList({current:1,pageSize:pagination.pageSize})">搜索</a-button>
            <a-button @click="resetList">清空</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="container-block" style="padding-bottom:0">
      <a-space style="margin-bottom:15px">
        <a-button v-if="btn_Add" type="primary" @click="toggleTask">新建</a-button>
        <a-button v-if="btn_BatchDelete" :disabled="deleteDisable" type="danger" ghost @click="deleteItem">批量删除</a-button>
        <template v-if="selectedRowKeys.length > 0">
          <a-tag> 已选择 {{selectedRowKeys.length}} 项 </a-tag>
        </template>
      </a-space>
      <a-table :columns="columns" :loading="taskLoading" :data-source="list.records"
        :row-selection="{selectedRowKeys, onChange: onSelectChange}" :row-key="record => record.id"
        :pagination="pagination">
        <a-tooltip slot="status" slot-scope="t">
          <span v-if="t === 0" style="color: #AAAAAA;">待优化</span>
          <span v-if="t === 1" style="color: #F59A23;"><a-spin size="small" class="cellSpin" />优化中</span>
          <span v-if="t === 2" style="color: #4B7902;">多配方有解</span>
          <span v-if="t === 3" style="color: gray;">停止优化</span>
          <span v-if="t === 4" style="color: #4B7902;">多配方有解，存在不可行配方</span>
          <span v-if="t === 11" style="color: #AAAAAA;"><a-spin size="small" class="cellSpin" />数据组装中</span>
          <span v-if="t === 12" style="color: #F59A23;"><a-spin size="small" class="cellSpin" />算法准备计算</span>
          <span v-if="t === 13" style="color: #F59A23;"><a-spin size="small" class="cellSpin" />结果保存中</span>
          <span v-if="t === 14" style="color: #F59A23;"><a-spin size="small" class="cellSpin" />算法计算中</span>
          <span v-if="t === 20" style="color: #F59A23;"><a-spin size="small" class="cellSpin" />数据组装完成</span>
          <span v-if="t === 98" style="color: #D9001B;">计算繁忙,请稍后再试</span>
          <span v-if="t === 99" style="color: #D9001B;">优化失败</span>
        </a-tooltip>
        <a-tooltip slot="taskName" slot-scope="text,record">
          <template slot="title">
            {{text}}
          </template>
          <img v-if="shixiaoShow(record)" style="width: 26px; position: relative; top: -3px; margin-right: -3px" src="@/assets/images/jieshui.svg" />
          <a @click="taskModify(record)">
            {{text}}
          </a>
        </a-tooltip>
        <a-space slot="option" slot-scope="text,record">
          <a-button type="link" @click="taskModify(record)">任务管理</a-button>
          <!-- <a-divider type="vertical" ></a-divider>
          <a-button type="link" :disabled="record.totalPrice === null" @click="taskDownload(record)">下载</a-button> -->
        </a-space>
        <span v-for="col in ['totalPrice','totalAmount','avgPrice']" :slot="col" :key="col" slot-scope="text">
          {{text|numberFixed(3)}}
        </span>
        <span slot="isEffective" slot-scope="text">
           <span v-if="text === 0" style="color: #AAAAAA;">否</span>
           <span v-if="text === 1" style="color: #4B7902;">是</span>
        </span>
      </a-table>
    </div>
    <formula-task-create :hidden="taskVisible" @cancel="toggleTask" @ok="createOk" />
  </div>
</template>

<script>
import FormulaTaskCreate from '../Nhf/Compound/modal/FormulaTaskCreate.vue'
import { formulaMixins } from './unitls'
const columns =[
  {
    title: '任务名称',
    dataIndex: 'taskName',
    scopedSlots: {customRender: 'taskName'},
    sorter: (a, b) => a.taskName.localeCompare(b.taskName,'zh'),
    ellipsis:true,
  },
    {
    title: '总价(元)',
    dataIndex: 'totalPrice',
    scopedSlots: {customRender: 'totalPrice'},
    sorter: (a, b) => a.totalPrice - b.totalPrice,

  },
  {
    title: '总量(吨)',
    dataIndex: 'totalAmount',
    scopedSlots: {customRender: 'totalAmount'},
    sorter: (a, b) => a.totalAmount - b.totalAmount,

  },
  {
    title: '均价(元/吨)',
    dataIndex: 'avgPrice',
    scopedSlots: {customRender: 'avgPrice'},
    sorter: (a, b) => a.avgPrice - b.avgPrice,
  },
  {
    title: '任务状态',
    dataIndex: 'status',
    ellipsis:true,
    scopedSlots: {customRender: 'status'},
  },
  {
    title: '截止时间(五日测算)',
    dataIndex: 'notifyEndTime',
    // ellipsis: true,
  },
  {
    title: '期间(五日测算)',
    dataIndex: 'rangeName',
    // ellipsis: true,
  },
  {
    title: '是否有效(五日测算)',
    dataIndex: 'isEffective',
    align: 'center',
    // ellipsis: true,
    scopedSlots: { customRender: 'isEffective' },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    // ellipsis:true,
  },
  {
    title: '用户',
    dataIndex: 'userName',
    width:160
  },
  {
    title: '创建时间',
    align:'center',
    dataIndex: 'createTime',
    sorter: (a, b) => new Date(a.createTime).getTime() - new Date(b.createTime).getTime(),
    sortDirections: ['descend', 'ascend'],
    width:180
  },
   {
    title: '操作',
    dataIndex:'option',
    width: 180,
    align:'center',
    scopedSlots: {customRender: 'option'}
  },
]
let timer = null
export default {
  components: { FormulaTaskCreate },
  mixins:[formulaMixins],
  data(){
    return {
      btn_Add:false,
      btn_BatchDelete:false,
      filterForm:{},
      selectItem:{},
      taskVisible:false,
      columns,
      taskLoading:false,
      list:{},
      search:{},
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
        total:0,
        pageSize: 0,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          window.clearTimeout(timer)
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          window.clearTimeout(timer)
          this.pagination.current = 1
          this.pagination.pageSize = pageSize
          this.getList({current:1,pageSize})
          window.localStorage.setItem('formulaTaskListPageSize',pageSize)
        } //每页多少条
      },
    }
  },
  mounted(){
    this.getList();
    this.getBtn();
  },
  watch :{
    '$route'() {
      this.getList()
    },
  },
  computed:{
    pageSizeC(){
      let pageSize = window.localStorage.getItem('formulaTaskListPageSize')
      let pageSizeC = pageSize ? Number(pageSize) : 20
      return pageSizeC
    },
    deleteDisable(){
      return this.selectedRowKeys.length === 0
    },
  },

  methods: {
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          this.testBtns = [];
          data && data.forEach(el => {
            if (el.path === '/formula/fivedaycalc') {
              el.children && el.children.forEach(item => {
                if (item.code === 'add') this.btn_Add = true;
                if (item.code === 'batchDelete') this.btn_BatchDelete = true;
              });
            }
          });
        }
      });
    },
    // 失效标识展示
    shixiaoShow(item){
      const now = new Date();
      const endTime = new Date(item.notifyEndTime);
      return now.getTime() > endTime.getTime()
    },
    polling(list=[]){
      let flag = list.some(el => el.status === 1 || el.status === 11 || el.status === 12 || el.status === 13 || el.status === 14 || el.status === 20)
      return flag
    },
    createOk(){
      this.getList()
      this.toggleTask()
    },

    toggleTask(){
      this.taskVisible = !this.taskVisible
    },

    async taskDownload(item){
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      const res = await this.$http('/nhf-app/formulataskformularaw/exportTaskFormulaRawAssessPage',{params:{taskId:item.id,aliasFlag},responseType:'arraybuffer'})
      this.downloadExcel(res,item)
    },

    downloadExcel(file,item){
      new Promise((res,rej) => {
        this.downloading = true
        const {taskName,updateTime} =item
        let blob = new Blob([file], { type:'application/vnd.ms-excel;charset=utf-8'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = `${taskName}-${updateTime}.xlsx`;
        a.click()
        window.URL.revokeObjectURL(a.href)
        objectUrl ? res(objectUrl) : rej(null)
      }).finally(()=>{
        this.downloading = false
      })
    },

    taskModify(item){
      const {id} = item
      this.$router.push(`/nhf-formula-editor?id=${id}`)
    },

    resetList(){
      this.search = {}
      this.getList()
    },

    listChange(page){
      let {pageSize} = page || {}
      window.localStorage.setItem('formulaTaskListPageSize',pageSize)
      window.clearTimeout(timer)
      this.getList({...this.tablePageChange(page),...this.filterData})
    },

    async getList(pagination) {
      let arg = this.search
      let {current,pageSize} = pagination || this.pagination
      pageSize = pageSize ? pageSize : this.pageSizeC
      let data = {
        factoryId:this.factoryId,
        staffId:this.staffId,
        size: pageSize,current,
      }
      if(arg && arg.taskDate){
        const [start,end] = arg.taskDate
        data = {...data,createTimeStart:`${start} 00:00:00`,createTimeEnd:`${end} 23:59:59`}
      }
      if(arg && arg.taskName){
        data = {...data,taskName:arg.taskName}
      }

      this.fetchGet({
        actions:this.selectFormulaTaskPage,
        isList: true,
        data,
        name:'list',
        // loading:'taskLoading'
      }).then(res => {
        let {data: resData,success} = res || {}
        if(success){
          let {records} = resData || {}
          let flag = this.polling(records)
          if(flag && window.location.href.indexOf('formula/formula-task') >= 0){
            timer = setTimeout(() => {
              this.getList(pagination)
            }, 5000);
          }
        }
      })

    },

    async deleteItem(){
      this.$confirm({
        title: '删除任务',
        content: '确定将选中的多配方任务删除吗?',
        okText: '继续',
        cancelText: '取消',
        onOk: async () =>{
          const data = {ids:this.selectedRows.map(i=>i.id).join()}
          await this.fetchPost({
            actions:this.deleteFormulaTaskLogic,
            data,
          })
          this.cleanSelect()
          this.getList()
        },
        onCancel(){},
      })
    }
  }
}
</script>
<style scoped>
.disabled{
  color: #888;
}
.list-item{
  font-size: 12px;
}
.dropdown-list{
   max-height:300px;
   width:240px;
   overflow: auto;
   margin:-10px;
}
</style>
